import { render, staticRenderFns } from "./recordAssociation.vue?vue&type=template&id=459f2e82&scoped=true"
import script from "./recordAssociation.vue?vue&type=script&lang=js"
export * from "./recordAssociation.vue?vue&type=script&lang=js"
import style0 from "./recordAssociation.vue?vue&type=style&index=0&id=459f2e82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f2e82",
  null
  
)

export default component.exports